// chatSlice.ts

import { createSlice } from "@reduxjs/toolkit";
import { getSelectedTopic, getSelectTopic, getUserConversations, startOrContinueChat } from "../Services/chatbox.service"; // Importing the async thunk from chatbox.service

// Define the state structure
interface AiResponse {
  response: string;
}

interface ChatData {
  conversation_id: string;
  chat_id: number;
  subject_id: number;
  title: string;
  ai_response: AiResponse;
  remaining_tokens: number;
  image_url: string | null;
}

interface ChatState {
  data: ChatData | null;
  loading: boolean;
  error: string | null;
  latestSubjectId:any;
  latestConversationId: any;
  isNewChat:boolean;
  isConfirm:boolean;
  conversations: any[];
}

// Initial state
const initialState: ChatState = {
  data: null,
  loading: false,
  error: null,
  latestSubjectId:null,
  latestConversationId:null,
  isNewChat:true,
  isConfirm : false,
  conversations: []
};

// Create the slice
const chatSlice = createSlice({
  name: "chatai",
  initialState,
  reducers: {
    setIsConfirm: (state, action) => {
      state.isConfirm = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(startOrContinueChat.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
  
      .addCase(startOrContinueChat.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
      })
      
      .addCase(startOrContinueChat.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string; 
      })

      .addCase(getUserConversations.fulfilled,(state,action)=>{
        state.latestSubjectId=action.payload.data?.conversations[0]?.subject_id;
        state.latestConversationId=action.payload.data?.conversations[0]?.conversation_id;
        state.conversations = action.payload.data?.conversations || [];
      })
       .addCase(getSelectTopic.fulfilled,(state)=>{
        state.isNewChat=false;
        state.isConfirm=true;
      })
       .addCase(getSelectedTopic.fulfilled,(state)=>{
        state.isNewChat=false;
      })
  },
});

export const chatReducers = chatSlice.actions;
// Export the reducer from the slice
export default chatSlice.reducer;
